import { j as e } from "./atoms-v218.js";
import { useTheme as l } from "styled-components";
import { TableHeaderCell as a, TableHeaderCellTextContainer as o } from "./atoms-v21271.js";
import { CalendarTableHeaderCellText as n } from "./atoms-v21272.js";
import { getTextCalculationConfig as i } from "./atoms-v21273.js";
function T(r) {
  const t = l();
  return /* @__PURE__ */ e.jsx(a, { children: /* @__PURE__ */ e.jsx(o, { children: /* @__PURE__ */ e.jsx(
    n,
    {
      ...r,
      textConfig: {
        ...i(t),
        text: r.label
      }
    }
  ) }) });
}
export {
  T as CalendarTableHeaderCell
};
